import React, { useCallback } from "react";
import { useStore, useSelector } from "react-redux";
import { Button, Form, Select, Space } from "antd";
import { useTranslation } from "react-i18next";
import NavigateDatePicker from "@/components/panel/NavigateDatePicker";
import PointFormItem from "@/components/panel/PointFormItem";
import styles from "./index.module.less";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

function NavigateForm() {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { select, dispatch } = useStore();
  const fields = useSelector(select.layer.selectFields);
  const loading = useSelector(select.layer.selectLoading);
  const compute = useCallback(
    (values) => {
      dispatch.layer.loadNavigate(values);
    },
    [dispatch]
  );
  const reset = useCallback(() => {
    dispatch.layer.reset();
    dispatch.panel.reset();
  }, [dispatch]);
  const valuesChangeHandle = useCallback(
    (changedValues) => {
      dispatch.layer.updateFields(changedValues);
    },
    [dispatch]
  );
  const checkStartEndPoint = (_, value) => {
    if (value.startPoint && value.endPoint) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("startAndEndPointValidator")));
  };

  console.log(fields);
  return (
    <div className={styles.navigateForm}>
      <Form
        {...layout}
        form={form}
        size="small"
        fields={fields}
        onFinish={compute}
        onValuesChange={(changedValues, allValues) => {
          valuesChangeHandle(changedValues, allValues);
        }}
        name="navigate-form"
      >
        <Form.Item name="time" label={t("startDate")}>
          <NavigateDatePicker />
        </Form.Item>
        <Form.Item name="shipType" label={t("shipType")}>
          <Select style={{ width: "100%" }}>
            <Select.Option value="NO_ICE">{t("noIce")}</Select.Option>
            <Select.Option value="PC1" disabled>
              {t("pc1")}
            </Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name="teuType" label={t("totalContainer")}>
          <Select style={{ width: "100%" }}>
            <Select.Option value="4000">4000TEU</Select.Option>
            <Select.Option value="10000">10000TEU</Select.Option>
            <Select.Option value="16000">16000TEU</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name="fuelType" label={t("fuel")}>
          <Select style={{ width: "100%" }}>
            <Select.Option value="LNG">LNG</Select.Option>
            <Select.Option value="HFO">HFO</Select.Option>
            <Select.Option value="MDO">MDO</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name="iceCount" label={t("iceCount")}>
          <Select style={{ width: "100%" }}>
            <Select.Option value="ICE_1">1</Select.Option>
            <Select.Option value="ICE_4">4</Select.Option>
            <Select.Option value="ICE_7">7</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name="faxType" label={t("faxType")}>
          <Select style={{ width: "100%" }}>
            <Select.Option value="FAX_0">0</Select.Option>
            <Select.Option value="FAX_50">50%</Select.Option>
            <Select.Option value="FAX_100">100%</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="vertex"
          label={t("startEnd")}
          rules={[
            {
              validator: checkStartEndPoint,
            },
          ]}
        >
          <PointFormItem />
        </Form.Item>
        <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              {t("submit")}
            </Button>
            <Button htmlType="button" onClick={reset}>
              {t("reset")}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
}

export default NavigateForm;
